export const ADMINISTRATION_API = {
    COUNTIES: '/administration/counties',
    USER_MANAGEMENT: {
        USERS_CACHE: '/administration/user-management/users-cache',
    },
};

export const PURCHASING_API = {
    BIKE_BRANDS: '/purchasing/bike-brands',
    BIKE_MODELS: '/purchasing/bike-models',
    BIKE_VARIANTS: '/purchasing/bike-variants',
    BIKE_INVENTORIES: '/purchasing/bike-inventories',
    BIKE_LEAD_UPGRADES: '/purchasing/bike-lead-upgrades',
    BIKE_HPI_CHECKS: '/purchasing/bike-hpi-checks',
    LEADS: '/purchasing/leads',
    LEADS_DUPLICATES: 'purchasing/leads/duplicates',
    LEADS_POSTCODE: '/purchasing/leads/postcode',
};



// WEBPACK FOOTER //
// ./src/common/constants/api.js